define('services/iusermanager',["require", "exports"], function (require, exports) {
    "use strict";
});

